module.exports = __webpack_public_path__ + "static/media/google-assistant.24730390.svg";